var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noTemplate"},[_vm._v("\n    无合同模板\n")])}
var staticRenderFns = []

export { render, staticRenderFns }